
import { onMounted, onBeforeUnmount } from 'vue'

export function useDocumentEvent(eventType, callback){
  onMounted(()=>{
    document.addEventListener(eventType, callback);
  });

  onBeforeUnmount(()=>{
    document.removeEventListener(eventType, callback);
  });
}